import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet, ViewStyle } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { layout, primitive, spacing } from 'styles/constants';

export const Section = ({ style, ...props }: BoxProps) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.section, !isMobile && styles.sectionDesktop, style],
  });
};

export const CardTitle = withTypography({
  variant: 'headerTwo',
  m: '$0',
  p: '$0',
  bold: true,
});

export const CardContent = ({ style, ...props }: BoxProps) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.cardContent, !isMobile && styles.cardContentDesktop, style],
  });
};

type CardProps = BoxProps & {
  $isFirst: boolean;
  $isLast: boolean;
};

export const Card = ({ $isFirst, $isLast, style, ...props }: CardProps) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [
      styles.card,
      !isMobile && styles.cardDesktop,
      !isMobile && !$isFirst && styles.cardDesktopNotFirst,
      !isMobile && !$isLast && styles.cardDesktopNotLast,
      style,
    ],
  });
};

export const CardImageContainer = ({ style, ...props }: BoxProps) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.cardImageContainer, !isMobile && styles.cardImageContainerDesktop, style],
  });
};

export const CardImage = makeUclComponent(Picture).withConfig({
  width: 'full',
  marginBottom: '$4',
  borderRadius: 'sm',
  borderBottomRadius: {
    md: '$0',
  },
});

export const CardBody = withTypography({ my: '$2', mx: '$0' });

type InheritedTextViewStyle = ViewStyle & {
  color?: string;
};

const styles = StyleSheet.create({
  card: {
    color: primitive.$bbqBrown,
    flex: 1,
    flexDirection: 'row-reverse',
    flexWrap: 'nowrap',
    marginBottom: spacing.$5,
  } as InheritedTextViewStyle,
  cardContent: {
    flex: 1,
    padding: spacing.$0,
  },
  cardContentDesktop: {
    padding: spacing.$2,
  },
  cardDesktop: {
    backgroundColor: primitive.$greyFive,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    flexDirection: 'column',
    flexWrap: 'wrap',
    marginBottom: 0,
  },
  cardDesktopNotFirst: {
    marginLeft: spacing.$2,
  },
  cardDesktopNotLast: {
    marginRight: spacing.$2,
  },
  cardImageContainer: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginLeft: spacing.$4,
    minWidth: 100,
  },
  cardImageContainerDesktop: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: spacing.$0,
    minWidth: layout.full,
  },
  section: {
    flexDirection: 'column',
    marginHorizontal: 'auto',
    paddingVertical: spacing.$6,
    width: layout.full,
  },
  sectionDesktop: {
    flexDirection: 'row',
    marginHorizontal: spacing.$0,
  },
});
